import type { AuthenticationRepository } from "@authentication/domain/repositories/authentication.repository";
import { authenticationTypes } from "@authentication/root/authentication-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class AuthenticatedUserIsLoggedUseCase {
    constructor(
        @inject(authenticationTypes.repositories.AuthenticationRepository)
        private readonly authenticationRepository: AuthenticationRepository,
    ) {}
    execute(): boolean {
        return this.authenticationRepository.hasAccessToken;
    }
}
